export const cycleThoughts: string[] = [
  '“I’ll check the articulating paper again.”',
  '“Maybe I should adjust this area a little more.”',
  '“The contacts look balanced… but the patient is still uncomfortable.”',
  '“What if I’m looking in the wrong place?”',
  '“I’ve already adjusted this once. I don’t want to keep removing tooth structure without being certain.”',
]

export const beforeItems: string[] = [
  'You start by looking for contacts.',
  'The articulating paper becomes your primary decision-making tool.',
  'You’re not always sure what information matters before making an adjustment.',
  'You may end up making small adjustments without a clearly defined sequence.',
  'Every case feels like it requires a completely different approach.',
  'You feel uncertain when the patient continues to report discomfort.',
]

export const afterItems: string[] = [
  'You follow a structured analysis pathway before reaching the articulating paper.',
  'You organize the case information before making decisions.',
  'You incorporate morphofunctional criteria into your analysis.',
  'You separate observation from interpretation.',
  'You use articulating paper as a refinement tool within the overall process.',
  'You document and validate your process with greater structure.',
]

export interface PainPoint {
  emoji: string
  text: string
}

export const painPoints: PainPoint[] = [
  {
    emoji: '😰',
    text: 'You have a patient who still reports discomfort after an occlusal adjustment, and you’re not sure what variable to reevaluate first.',
  },
  {
    emoji: '🦷',
    text: 'You see marks on the articulating paper, but you’re not completely confident that the marked contact is actually what should be modified.',
  },
  {
    emoji: '🤔',
    text: 'You struggle with knowing what to evaluate before beginning an adjustment.',
  },
  {
    emoji: '🔄',
    text: 'You’ve had cases where several small adjustments were needed because the initial result didn’t feel right to the patient.',
  },
  {
    emoji: '😓',
    text: 'When dealing with rehabilitation or post-orthodontic cases, you wish you had a more structured way to organize your analysis.',
  },
  {
    emoji: '⏱️',
    text: 'You spend too much time going through different resources because you don’t have one clear reference system.',
  },
  {
    emoji: '😩',
    text: 'You want to move beyond “eyeballing it” and develop a more organized framework for analyzing occlusal cases.',
  },
]

export interface PurchaseNotice {
  name: string
  city: string
  country: string
  flag: string
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Valentina R.', city: 'Bogotá', country: 'Colombia', flag: '🇨🇴' },
  { name: 'Dr. Miguel A.', city: 'Guadalajara', country: 'Mexico', flag: '🇲🇽' },
  { name: 'Camila T.', city: 'Santiago', country: 'Chile', flag: '🇨🇱' },
  { name: 'Dr. Esteban V.', city: 'Quito', country: 'Ecuador', flag: '🇪🇨' },
  { name: 'Paula G.', city: 'Buenos Aires', country: 'Argentina', flag: '🇦🇷' },
  { name: 'Dr. Ricardo M.', city: 'Lima', country: 'Peru', flag: '🇵🇪' },
  { name: 'Sofía N.', city: 'Madrid', country: 'Spain', flag: '🇪🇸' },
  { name: 'Dr. Andrés L.', city: 'Caracas', country: 'Venezuela', flag: '🇻🇪' },
  { name: 'Gabriela O.', city: 'San José', country: 'Costa Rica', flag: '🇨🇷' },
  { name: 'Dr. Julián P.', city: 'Montevideo', country: 'Uruguay', flag: '🇺🇾' },
  { name: 'Daniela F.', city: 'Asunción', country: 'Paraguay', flag: '🇵🇾' },
  { name: 'Dr. Héctor C.', city: 'Santo Domingo', country: 'Dominican Rep.', flag: '🇩🇴' },
]
